import clsx from "clsx";

// Interfaces
import { IActionsProps } from "../interfaces";

// MUI
import { IconButton } from "@mui/material";

// Icons
import CommentIcon from "@mui/icons-material/Comment";

export default function OptionActionControl(props: Readonly<IActionsProps>) {
	const {
		option = null,
		sx = null,
		icon = <CommentIcon fontSize="small" />,
		classes = "",
		isControlledAction = false,
		selected = false,
		disabled = false,
		onOptionClickAction = () => {},
	} = props;

	if (!isControlledAction) {
		return null;
	}

	return (
		<IconButton
			className={clsx({
				"!p-[4px]": true,
				"[&_svg]:text-white": selected,
				"[&_svg]:!text-disabled": disabled,
				[classes]: Boolean(classes),
			})}
			edge="end"
			aria-label="comments"
			disabled={disabled}
			sx={sx}
			onClick={(event) => {
				event.stopPropagation();
				onOptionClickAction?.(option);
			}}
		>
			{icon}
		</IconButton>
	);
}
